import { MobiDocument } from './MobiDocument';

export class ClasseScolaireDocument extends MobiDocument{ 
    private _id : string;
    private _rev : string;
    private id : number;
    private nom : string;
    private etablissementscolaire_id : number;
    private obsolete : boolean;
    private anneeScolaire_id:number;


    
    public constructor(classes : any){
        super()
        this._id = classes._id;
        this._rev = classes._rev;
        this.id = classes.id;
        this.nom = classes.nom;
        this.etablissementscolaire_id = classes.etablissementscolaire_id;
        this.obsolete = classes.obsolete;
        this.anneeScolaire_id=classes.anneeScolaire_id
    }

    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getNom(): string {
        return this.nom;
    }

    public setNom(nom: string): void {
        this.nom = nom;
    }

    public getEtablissementscolaire_id(): number {
        return this.etablissementscolaire_id;
    }

    public setEtablissementscolaire_id(etablissementscolaire_id: number): void {
        this.etablissementscolaire_id = etablissementscolaire_id;
    }

    public isObsolete(): boolean {
        return this.obsolete;
    }

    public setObsolete(obsolete: boolean): void {
        this.obsolete = obsolete;
    }

    public getAnneeScolaireId(): number {
        return this.anneeScolaire_id;
    }

    public setAnneeScolaireId(id_anneeScolaire: number): void {
        this.anneeScolaire_id = id_anneeScolaire;
    }
}